<template>
    <div class="mx-auto">
        <page-title :title="$t('sideMenu.budgetModule')"></page-title>
        <div class="card mt-3">
            <div class="card-header bg-primary text-white">
                <div class="h5">{{ $t('budget.budgetFor') }} {{ selectedYear }} {{ $t('annualCatalog.year') }}</div>
            </div>
            <div class="card-body">
                <div class="col-12 mb-3" v-if="years && years.length > 0">
                    <label class="font-weight-bold">{{ $t('planning.year') }}</label>
                    <select class="form-control" v-model="selectedYear">
                        <option v-for="year in years" :value="year" :selected="year == selectedYear">{{ year }}</option>
                    </select>
                </div>
                <div class="loading" v-if="loading"></div>
                <table class="table table-bordered table-responsive mt-3"
                       v-if="!loading && budget.items && budget.items.length > 0">
                    <thead>
                    <tr>
                        <th></th>
                        <th colspan="3">{{ $t('budgetModule.plan') }}</th>
                        <th colspan="3">{{ $t('budgetModule.expense') }}</th>
                        <th>{{ $t('budgetModule.financing') }}</th>
                        <th>{{ $t('budgetModule.balance') }}</th>
                    </tr>
                    <tr>
                        <th class="required">{{ $t('budgetModule.budgetPosition') }}</th>
                        <th>{{ $t('budgetModule.qty') }}</th>
                        <th>{{ $t('budgetModule.singlePriceByTariff') }}</th>
                        <th>{{ $t('budgetModule.total') }}</th>

                        <th>{{ $t('budgetModule.qty') }}</th>
                        <th>{{ $t('budgetModule.singlePriceByTariff') }}</th>
                        <th>{{ $t('budgetModule.total') }}</th>

                        <th><!--Нип / Външно--></th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    <budget-module-item v-for="(item, index) in budget.items" :item="item"
                                        :index="index"
                                        @deleteItem="deleteItem"
                                        @totalChanged="totalChanged"
                                        @financingTypeChanged="onFinancingTypeChanged"></budget-module-item>
                    </tbody>
                    <tfoot class="text-muted">
                    <tr>
                        <td colspan="3">{{ $t('budgetModule.totalNijFinancing') }}</td>
                        <td>{{ planTotalNijFinancing }}</td>
                        <td colspan="2"></td>
                        <td>{{ expenseTotalNijFinancing }}</td>
                        <td></td>
                        <td>{{ nijFinancingBalance }}</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td colspan="3">{{ $t('budgetModule.totalExternalFinancing') }}</td>
                        <td>{{ planTotalNijExternalFinancing }}</td>
                        <td colspan="2"></td>
                        <td>{{ expenseTotalExternalFinancing }}</td>
                        <td></td>
                        <td>{{ externalFinancingBalance }}</td>
                        <td></td>
                    </tr>
                    </tfoot>
                </table>
                <div>
                    <button class="btn btn-primary" @click="addRow">{{ $t('add') }}</button>
                    <button class="btn btn-primary" @click="onSave">{{ $t('save') }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { FinancingTypes } from '@/models/enums';
import { BudgetModuleItemModel, BudgetModuleModel } from '@/models/models';
import BudgetModuleItem from '../../../components/budget/BudgetModuleItem';
import PageTitle from '../../../components/common/PageTitle';

export default {
    inject: ['$validator'],
    components: {
        BudgetModuleItem,
        PageTitle
    },
    data() {
        return {
            budget: new BudgetModuleModel(),
            itemsToDelete: [],
            total: 0,
            years: [],
            selectedYear: new Date().getFullYear(),
            loading: false,
            planTotalNijFinancing: 0,
            expenseTotalNijFinancing: 0,
            planTotalNijExternalFinancing: 0,
            expenseTotalExternalFinancing: 0,
            eventsByYear: null,
            eventsBudgetModelItems: []
        }
    },
    watch: {
        selectedYear: function (newVal, oldVal) {
            this.budget.year = newVal;
            this.loadByYear(newVal);
            this.loadEventsData();
        }
    },
    methods: {
        loadByYear(year) {
            this.loading = true;
            this.budget.items = [];
            this.$http.get(`/api/BudgetModule/GetByYear/${year}`).then(result => {
                if (result.data && result.data.id) {
                    this.budget = new BudgetModuleModel(result.data);
                    //this.calculateFinancingTypesTotals();
                }
                this.loading = false;
            }).catch(error => {
                // TODO:
                this.loading = false;
            });
        },
        addRow() {
            this.budget.items.push(new BudgetModuleItemModel());
        },
        deleteItem(index) {
            const itemToDelete = this.budget.items[index];
            if (itemToDelete.id) {
                this.itemsToDelete.push(itemToDelete.id);
            }
            this.budget.items.splice(index, 1);
        },
        totalChanged() {
            this.calculateTotal();
        },
        calculateTotal() {
            let totalSum = 0;
            this.budget.items.forEach(item => {
                if (item.total) {
                    totalSum += item.total;
                }
            })
            this.total = Math.round(totalSum * 100) / 100;
        },
        loadYears() {
            let currentYear = this.selectedYear;
            const years = 150;
            for (let i = currentYear - years; i <= currentYear + years; i++) {
                this.years.push(i);
            }

            this.budget.year = this.selectedYear;
            this.loadByYear(this.selectedYear);
        },
        loadEventsData() {
            this.loadEventsByYear();
        },
        loadEventsByYear() {
            this.$http.get(`api/events/eventsByYear/${this.budget.year}`).then(response => {
                if (response) {
                    this.eventsByYear = [];
                    response.data.forEach(event => {
                        this.eventsByYear.push(event.registerEntityId);
                    })
                }
            }).then(result => {
                this.loadExpensesByEventIds();
            }).catch(error => {

            })
        },
        loadExpensesByEventIds() {
            this.eventsBudgetModelItems = [];
            this.$http.post(`/api/Expenses/GetByRegisterEntityIds/`, this.eventsByYear).then(result => {
                if (result.data) {
                    result.data.forEach(item => {
                        let eventBudgetItem = this.budget.items.find(e => e.tariffItemId === item.tariffEntityItemId);

                        if (eventBudgetItem) {
                            eventBudgetItem.expensePrice = item.price;
                            eventBudgetItem.expenseQty = item.qty;
                            eventBudgetItem.tariffItemId = item.tariffEntityItemId
                            eventBudgetItem.expenseTotal = Math.round(item.qty * item.price * 100) / 100;
                        } else {
                            let budgetItemModel = new BudgetModuleItemModel();

                            budgetItemModel.expensePrice = item.price;
                            budgetItemModel.expenseQty = item.qty;
                            budgetItemModel.tariffItemId = item.tariffEntityItemId
                            budgetItemModel.expenseTotal = Math.round(item.qty * item.price * 100) / 100;

                            this.budget.items.push(budgetItemModel);
                        }

                        //this.eventsBudgetModelItems.push(budgetItemModel);
                    })
                }
            }).then(res => {
                this.calculateFinancingTypesTotals();
            }).catch(error => {
                this.$vs.notify({
                    title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                    text: this.$helpers.errorText(error),
                    color: 'danger',
                    time: this.$store.getters.notificationDuration
                })
            }).then(() => this.loading = false);
        },
        loadBudgetPlanByEventIds() {
            this.$http.post(`/api/Budget/GetByRegisterEntityIds/`, this.eventsByYear).then(result => {
                if (result.data) {
                    result.data.forEach(item => {
                        let eventBudgetItem = this.eventsBudgetModelItems.find(e => e.tariffItemId === item.tariffEntityItemId);

                        if (eventBudgetItem) {
                            eventBudgetItem.price = item.price;
                            eventBudgetItem.qty = item.qty;
                            eventBudgetItem.total = Math.round(item.qty * item.price * 100) / 100;
                        }
                    })
                    this.budget.items = this.budget.items.concat(this.eventsBudgetModelItems);
                }
            }).then(res => {
                this.calculateFinancingTypesTotals();
            }).catch(error => {
                this.$vs.notify({
                    title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                    text: this.$helpers.errorText(error),
                    color: 'danger',
                    time: this.$store.getters.notificationDuration
                })
            }).then(() => this.loading = false);
        },
        onSave() {
            this.$validator.validateAll().then(result => {
                if (result) {
                    if (this.budget.id) {
                        this.edit();
                    } else {
                        this.create();
                    }
                }
            })
        },
        onFinancingTypeChanged() {
            this.calculateFinancingTypesTotals();
        },
        calculateFinancingTypesTotals() {
            this.planTotalNijFinancing = 0;
            this.expenseTotalNijFinancing = 0;
            this.planTotalNijExternalFinancing = 0;
            this.expenseTotalExternalFinancing = 0;

            this.budget.items.forEach(item => {
                //if (item.financingId) {
                if (item.financingId == FinancingTypes.Budget) {
                    this.planTotalNijFinancing += item.total;
                    this.expenseTotalNijFinancing += item.expenseTotal;
                } else {
                    this.planTotalNijExternalFinancing += item.total;
                    this.expenseTotalExternalFinancing += item.expenseTotal;
                }
            });

            this.planTotalNijFinancing = Math.round(this.planTotalNijFinancing * 100) / 100;
            this.expenseTotalNijFinancing = Math.round(this.expenseTotalNijFinancing * 100) / 100;
            this.planTotalNijExternalFinancing = Math.round(this.planTotalNijExternalFinancing * 100) / 100;
            this.expenseTotalExternalFinancing = Math.round(this.expenseTotalExternalFinancing * 100) / 100;
        },
        create() {
            this.loading = true;
            this.$http.post('/api/BudgetModule', this.budget).then(result => {
                this.loading = false;
                this.$vs.notify({
                    title: this.$t('notifications.success'),
                    text: this.$t('notifications.successfulSavedData'),
                    color: 'success'
                });
                // TODO: Refresh page
            }).catch(error => {
                this.loading = false;
                this.$vs.notify({
                    title: this.$t('notifications.error'),
                    text: this.$t('notifications.errorDataNotSaved'),
                    color: 'danger'
                });
            });
        },
        edit() {
            this.loading = true;
            this.$http.put('/api/BudgetModule', this.budget).then(result => {
                this.loading = false;
                this.$vs.notify({
                    title: this.$t('notifications.success'),
                    text: this.$t('notifications.successfulSavedData'),
                    color: 'success'
                });
            }).catch(error => {
                this.loading = false;
                this.$vs.notify({
                    title: this.$t('notifications.error'),
                    text: this.$t('notifications.errorDataNotSaved'),
                    color: 'danger'
                });
            });
        }
    },
    computed: {
        nijFinancingBalance() {
            return Math.round((this.planTotalNijFinancing - this.expenseTotalNijFinancing) * 100) / 100;
        },
        externalFinancingBalance() {
            return Math.round((this.planTotalNijExternalFinancing - this.expenseTotalExternalFinancing) * 100) / 100;
        }
    },
    mounted() {
        this.loadYears();
        this.loadEventsData();
    }
}
</script>
